import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailsFlow = _resolveComponent("DetailsFlow")!
  const _component_ProductKeysOverview = _resolveComponent("ProductKeysOverview")!
  const _component_CompanyDeatils = _resolveComponent("CompanyDeatils")!
  const _component_SubscriptionDetails = _resolveComponent("SubscriptionDetails")!
  const _component_UserSubDetails = _resolveComponent("UserSubDetails")!
  const _component_UserDetails = _resolveComponent("UserDetails")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DetailsFlow, {
      overview: "Product Keys",
      detail: _ctx.detailName
    }, null, 8, ["detail"]),
    (_ctx.showCompanyDetails && !_ctx.showCompanySubDetails && _ctx.showUserDetails)
      ? (_openBlock(), _createBlock(_component_ProductKeysOverview, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.showCompanyDetails && !_ctx.showCompanySubDetails)
      ? (_openBlock(), _createBlock(_component_CompanyDeatils, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.showCompanySubDetails)
      ? (_openBlock(), _createBlock(_component_SubscriptionDetails, { key: 2 }))
      : _createCommentVNode("", true),
    (!_ctx.showUserDetails)
      ? (_openBlock(), _createBlock(_component_UserSubDetails, { key: 3 }))
      : _createCommentVNode("", true),
    (!_ctx.showUserDetails)
      ? (_openBlock(), _createBlock(_component_UserDetails, { key: 4 }))
      : _createCommentVNode("", true)
  ]))
}